export function onAnimationEnd(event) {
    event.persist();
    if (event.target.classList.value.includes('animation--fadeIn')) {
        // console.log('onAnimationEnd', event.target.classList.value)
        event.target.classList.add('end-animate');
        event.target.classList.remove('is-animate');
    }
}
